// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import styled from 'styled-components'
import { Button, Nav as NextGenNav, Aside } from '@teamnine/pcj-ui-v2'

const TOP_APP_BAR_HEIGHT = '86px'
const EXPANDED_NAV_WIDTH = '275px'
const COLLAPSED_NAV_WIDTH = '100px'

export const CollapseButton = styled(Button).attrs({
  variant: 'primary',
  appearance: 'outlined',
})<{
  $isCollapsed: boolean
  $isFullScreen?: boolean
}>`
  &&& {
    color: ${({ theme }) => theme.colors.nggray700};
    background-color: ${({ theme }) => theme.colors.nggray100};
    position: fixed;
    left: ${({ $isCollapsed }) =>
      $isCollapsed
        ? `calc(${COLLAPSED_NAV_WIDTH} - 16px)`
        : `calc(${EXPANDED_NAV_WIDTH} - 16px)`};
    z-index: 998;
    top: calc(${TOP_APP_BAR_HEIGHT} + 48px);
    transition: left 300ms ease-in-out;
    min-height: unset;
    height: 32px;
    width: 32px;
    border: 1px solid ${({ theme }) => theme.colors.nggray600};
    border-radius: 16px;
    ${({ $isFullScreen }) => $isFullScreen && 'display: none;'}

    ${({ theme }) => theme.mediaQueries.laptop} {
      display: none;
    }
  }
`

export const Nav = styled(NextGenNav)<{
  isCollapsed: boolean
  isFullScreen?: boolean
}>`
  z-index: 98;
  height: 100%;
  position: relative;

  width: ${({ isCollapsed, isFullScreen }) =>
    isCollapsed && !isFullScreen
      ? COLLAPSED_NAV_WIDTH
      : isFullScreen
        ? '0'
        : EXPANDED_NAV_WIDTH};
  min-width: ${({ isCollapsed, isFullScreen }) =>
    isCollapsed && !isFullScreen
      ? COLLAPSED_NAV_WIDTH
      : isFullScreen
        ? '0'
        : EXPANDED_NAV_WIDTH};
  ${({ isFullScreen }) => isFullScreen && 'padding: 0;'}

  transition:
    width 300ms ease-in-out,
    min-width 300ms ease-in-out !important;

  ${({ theme }) => theme.mediaQueries.mobile} {
    height: 100%;
    margin-top: 0;
    width: 100%;
  }
`

export const Display = styled(Aside.Display)`
  width: ${EXPANDED_NAV_WIDTH};
  min-width: ${EXPANDED_NAV_WIDTH};
  background-color: transparent;
`

export const Content = styled(Aside.Content)`
  && {
    padding: 0;
    width: ${EXPANDED_NAV_WIDTH};
    background-color: ${({ theme }) => theme.colors.white};
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    z-index: 10000;
  }
`
